module.exports = __webpack_public_path__ + "img/img2.caf4b4fe.jpg";